import React, { useState } from 'react';
import Icon from '@common/assets';
import PositionTextListItem from '@components/common/positionTextListItem';
import PositionTextListItemVO from '@domain/vo/common/PositionTextListItemVO';
import SliderButton from '@components/common/sliderButton';

import classnames from 'classnames/bind';
import styles from './positionCompanyList.module.scss';
const cx = classnames.bind(styles);

interface PositionCompanyListProps {
  positions: PositionTextListItemVO[];
  setModalVisible: (modalVisible: boolean) => void;
}

const PositionCompanyList = ({ positions, setModalVisible }: PositionCompanyListProps) => {
  const [positionIndex, setPositionIndex] = useState(0);
  // 이동되는 크기(카드(294) + 여백(24))
  const moveOffset = 318;
  // 보여지는 갯수
  const cardViewCount = 2;
  const positionCount = positions?.length ?? 0;
  const width = 306 * Math.ceil(positionCount / 2);
  const height = positionCount > 6 ? 368 : 172;
  const flexWrap = positionCount > 6 ? 'wrap' : 'nowrap';
  const isPrev = positionIndex > 0;

  const getIsNext = () => {
    if (positionCount > 6) return positionIndex < positions.length / 2 - cardViewCount;
    return positionIndex < positions.length - cardViewCount;
  };

  const handlePrev = () => {
    setPositionIndex(positionIndex - 1);
  };

  const handleNext = () => {
    setPositionIndex(positionIndex + 1);
  };

  if (!positions || positions.length === 0) return null;

  const positionEls = positions?.map((positionCompany, i) => {
    return (
      <li className={cx('listItem')} key={positionCompany.positionSn}>
        <PositionTextListItem positionData={positionCompany} isInCompanyList={true} />
      </li>
    );
  });

  return (
    <div className={cx('positionCompanyArea')}>
      <div className={cx('positionCompanyListArea')}>
        <SliderButton visible={isPrev} type={'prev'} handleClick={handlePrev} />
        <div className={cx('positionCompanyListWrap')}>
          <ul
            style={{
              transform: `translateX(${-positionIndex * moveOffset}px)`,
              width: `${width}px`,
              height: `${height}px`,
              flexWrap: flexWrap,
            }}
            className={cx('positionCompanyList')}
          >
            {positionEls}
          </ul>
        </div>
        <SliderButton visible={getIsNext()} type={'next'} handleClick={handleNext} />
      </div>

      {positionCount > 0 && (
        <a className={cx('btnMore')} role="button" onClick={() => setModalVisible(true)}>
          {positionCount}개 포지션 모두보기
          <Icon name="arrowRightLight" width={24} height={24} />
        </a>
      )}
    </div>
  );
};

export default PositionCompanyList;
